/* Publish by EComposer at 2026-10-07 16:15:57*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-jc3jtfbx1h"]=  window.__ectimmers["ecom-jc3jtfbx1h"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-jc3jtfbx1h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jc3jtfbx1h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5ffmai19gks').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5ffmai19gks', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-jul44a08ji').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-jul44a08ji', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ubkpzwdehhs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ubkpzwdehhs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e6x64k7szls').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e6x64k7szls', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ofnacy8ol29').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ofnacy8ol29', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-l459kc492d').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l459kc492d', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0v7k7nf7x64').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0v7k7nf7x64', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-y9qefe20sds').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-y9qefe20sds', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ir39bs6w91').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ir39bs6w91', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-b58d4in3aod').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-b58d4in3aod', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-5mdl0ma09ri').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-5mdl0ma09ri', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-l9skbhbwm9"]=  window.__ectimmers["ecom-l9skbhbwm9"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-l9skbhbwm9"]["371qbsvc7"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-l9skbhbwm9').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-l9skbhbwm9', settings: {"animation":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-a6hingoxtwt').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-a6hingoxtwt', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-ws7j2sbuz4"]=  window.__ectimmers["ecom-ws7j2sbuz4"] || {};
const t=this.$el;if(!t||!this.isLive)return;const e=t.querySelector(".element__featured--wrapper-list");if(e){let i={top:0,left:0,x:0,y:0};const o=function(r){const a=r.clientX-i.x;e.scrollLeft=i.left-a},n=function(){e.removeEventListener("mousemove",o),e.removeEventListener("mouseup",n),e.style.cursor="default",e.style.removeProperty("user-select")},s=function(r){e.style.cursor="grabbing",e.style.userSelect="none",i={left:e.scrollLeft,top:e.scrollTop,x:r.clientX,y:r.clientY},e.addEventListener("mousemove",o),e.addEventListener("mouseup",n)};e.addEventListener("mousedown",s),e.addEventListener("mouseleave",n)}

                    });
                    
                        document.querySelectorAll('.ecom-ws7j2sbuz4').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ws7j2sbuz4', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ar5heh41i1v').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ar5heh41i1v', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o5zsxs2avd8').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o5zsxs2avd8', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-q6zuvk57k3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-q6zuvk57k3', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-zurqvaay5vi').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-zurqvaay5vi', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ugo4qkdoqk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ugo4qkdoqk', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-049p1y8avkbn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-049p1y8avkbn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-hmnz5bia5ic').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-hmnz5bia5ic', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0is63hmnmkli').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0is63hmnmkli', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-o4kxpi4c85p').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-o4kxpi4c85p', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j8dh2f2kjrj').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j8dh2f2kjrj', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-33kyh6d7p8a').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-33kyh6d7p8a', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-k3734htrprg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-k3734htrprg', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4jq8t2gw3se').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4jq8t2gw3se', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-sqhw09rlgdf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sqhw09rlgdf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-i7zvy40lx7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-i7zvy40lx7i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-lgy49818zdn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-lgy49818zdn', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ypciflhgu6k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ypciflhgu6k', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-sa1ij8ggwhn"]=  window.__ectimmers["ecom-sa1ij8ggwhn"] || {};
let t=this.$el;if(!t)return;let e=t.querySelectorAll(":scope > .tabs__wrapper > div > .tabs__navs > .tabs__navs--items > .tabs__nav"),i=t.querySelectorAll(":scope > .tabs__wrapper > .core__group--items > .tab__item"),o=this.settings.action;function n(a,l){a.classList.contains("ecom-item-active")||(e.forEach(c=>c.classList.remove("ecom-item-active")),i.forEach(c=>c.classList.remove("ecom-item-active")),a.classList.add("ecom-item-active"),i[l].classList.add("ecom-item-active"),setTimeout(()=>{const c=i[l];c&&c.querySelectorAll(".ec_splide").forEach(d=>{var m;(m=d.ec_splide)==null||m.refresh()})},50),r())}e.forEach((a,l)=>{o==="click"||window.screen.width<1025?a.onclick=()=>n(a,l):a.onmouseover=()=>n(a,l)});function s(){let a=window.location.hash;if(a){let l=t.querySelector(`[data-target="${a}"]`);if(l){l.click();let c=new MouseEvent("mouseover",{bubbles:!0,cancelable:!0,view:window});l.dispatchEvent(c);let g=l.getBoundingClientRect().top+window.pageYOffset-window.innerHeight/2;window.scrollTo(0,g)}}}setTimeout(()=>{s()},300);function r(){setTimeout(()=>{const a=t.querySelector(".tab__item.ecom-item-active");a&&a.querySelectorAll(".ec_splide").forEach(l=>{var c;(c=l.ec_splide)==null||c.refresh()}),window.dispatchEvent(new window.Event("resize"))},100)}window.addEventListener("hashchange",s,!1)

                    });
                    
                        document.querySelectorAll('.ecom-sa1ij8ggwhn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-sa1ij8ggwhn', settings: {"action":"click"},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-4xj5ex2sp35"]=  window.__ectimmers["ecom-4xj5ex2sp35"] || {};
const t=function(r){if(window.EComModal)return r();if(window.EComposer&&typeof window.EComposer.loadVendor=="function"){window.EComposer.loadVendor("modal_js").then(function(){window.EComModal&&r()});return}let a=0;const l= window.__ectimmers["ecom-4xj5ex2sp35"]["db4r1cjkg"] = setInterval(function(){window.EComModal?(clearInterval(l),r()):++a>=300&&clearInterval(l)},50)};if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&this.$el){var e=this.$el.querySelector("[ecom-modal]"),i=this.id;t(function(){new window.EComModal(e,{cssClass:["ecom-container-lightbox-"+i]})})}let o=this.$el;if(!o)return;function n(r){const a=r.getBoundingClientRect();return a.top>=0&&a.left>=0&&a.bottom-r.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&a.right<=(window.innerWidth||document.documentElement.clientWidth)}function s(){let r=o.querySelector(".ecom-element.ecom-base-image"),a=o.closest(".core__row--columns");r&&(n(r)?(r.classList.add("image-highlight"),a.setAttribute("style","z-index: unset")):(r.classList.remove("image-highlight"),a.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){s()})

                    });
                    
                        document.querySelectorAll('.ecom-4xj5ex2sp35').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xj5ex2sp35', settings: {"link":"none","lightbox":"no"},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-qyp1p809yni').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-qyp1p809yni', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-91tyw8t858g').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-91tyw8t858g', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1g4c9ksn9wy').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1g4c9ksn9wy', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-4xyu45gzngg').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-4xyu45gzngg', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1kv2r3b94x3').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1kv2r3b94x3', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-f7k276zk2sk').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-f7k276zk2sk', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rb0h2vh20ak').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rb0h2vh20ak', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-iaahp9fuj6').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-iaahp9fuj6', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}